
import React from "react"

import { Container, PrimaryButton, TabsPanel, palette } from '@dev/ee-components';
import { Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { push as Push } from 'redux-first-history';
import { useDispatch, useSelector } from 'react-redux';

import { useAccessLevel } from "@/services/hooks/useAccessLevel";
import { AccessLevel } from "@dev/ee-api/ee-api-models";
import { sendEventToGTM } from "@dev/ee-tools";
import { CheckoutsPaths, pathsParams } from '@/services/dictionaries/Paths';
import { getConfigStore } from '@/store/config/actions';
import useMobile from '@/services/hooks/useMobile';
import { CheckoutList } from "./CheckoutsList";
import { CheckoutDraftsList } from "./DraftsList";
import { CheckoutsListProps, CheckoutTabName, TabNameEnum } from "./CheckoutsInterface"

const getTabName = (tabIndex: number): TabNameEnum => {
    const tabs = [TabNameEnum.Checkout, TabNameEnum.Draft];
    return tabs[tabIndex];
};

const getScreenIndexFromName = (screenName: string): number => {
    if (screenName === CheckoutTabName.Draft) {
        return 1;
    }

    return 0;
};

export const Checkouts = (props: CheckoutsListProps):  JSX.Element => {
    const {
        match: { params },
    } = props;
    const { t } = useTranslation();
    const { isStandalone } = useSelector(getConfigStore);
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const { hasAccessLevel } = useAccessLevel();
    const canModifyCheckouts = hasAccessLevel(AccessLevel.ModifyLandingPagesCheckout);

    const handleTabChange = (e, clickedTab: number): void => {
        dispatch(Push(CheckoutsPaths.Checkouts.replace(':tabName', getTabName(clickedTab))));
    }

    const tabNameFromParams = params.tabName ?? CheckoutTabName.Checkout;

    return (
        <Container>
            <TabsPanel
                tabBackground={isMobile || isStandalone ? '' : palette.basic.paper}
                title={t('checkouts')}
                isMobile={false}
                value={getScreenIndexFromName(tabNameFromParams)}
                onChange={handleTabChange}
                tabs={[
                    {
                        label: t('checkout'),
                        id: CheckoutTabName.Checkout,
                    },
                    {
                        label: t('draft'),
                        id: CheckoutTabName.Draft,
                    },
                ]}
                additionalHeaderContent={
                    canModifyCheckouts && !isMobile && (
                        <PrimaryButton
                            text={t('createcheckout')}
                            onClick={(): void => {
                                sendEventToGTM("start_creating_checkout");
                                dispatch(Push( 
                                    CheckoutsPaths.CheckoutCreator.replace(
                                    pathsParams.nameOptional,
                                    '')))
                            }}
                        />
                    )
                }
            />
            <Switch>
                <Route exact component={CheckoutList} path={CheckoutsPaths.Checkouts.replace(':tabName?', '')} />
                <Route exact component={CheckoutList} path={CheckoutsPaths.CheckoutsList} /> 
                <Route exact component={CheckoutDraftsList} path={CheckoutsPaths.CheckoutsDraftList} />
            </Switch>

        </Container>
    )
}